import {
    GET_NUMBER_CONFIRMATION,
    GET_NUMBER_CONFIRMATION_SUCCESS,
    RESEND_CONFIRMATION_CODE,
    RESEND_CONFIRMATION_CODE_SUCCESS,
    RESEND_CONFIRMATION_CODE_ERROR
} from '../../constants/actions/auth';

import * as authService from '../../services/authService';
import {notification}   from '../../helperFunctions';

export function getNumberConfirmation(formData, isResend) {
    return dispatch => {
        authService.getNumberConfirmation(formData).then(() => {
            dispatch({type: GET_NUMBER_CONFIRMATION_SUCCESS, payload: formData});
            notification.ref.show({message: 'Confirmation code sent'});
        });
    };
}

export function resendConfirmationCode(formData) {
    return dispatch => {
        dispatch({type: RESEND_CONFIRMATION_CODE});
        authService.resendConfirmationCode(formData).then((res) => {
            if(res.data.response_code === 0) {
                dispatch({type: RESEND_CONFIRMATION_CODE_SUCCESS, payload: {formData, attempts: res.data.payload.verification.attempts}});
                notification.ref.show({message: 'Confirmation code sent'});
            }
            else {
                dispatch({type: RESEND_CONFIRMATION_CODE_ERROR, payload: res.data.error});
                notification.ref.show({message: res.data.error, isError: true});
            }
        });
    };
}